
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/6b84a11e410079b56c6291a27cbf72c2/f6705f108820539b719f4aab61e9054b.jpeg" 
                alt="Henatos Limited Logo" 
                className="h-10 w-auto"
              />
              <div>
                <h3 className="text-xl font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>Henatos Limited</h3>
                <p className="text-cyan-300 text-sm">Africa's Trusted Partner in Commodities</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Building Africa's most reliable trade network for premium air-dried cow hides, 
              connecting suppliers across East and Southern Africa to buyers in Nigeria.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:accounts@henatosbiz.com" className="text-cyan-300 hover:text-white transition-colors">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-mail-line text-xl"></i>
                </div>
              </a>
              <a href="https://wa.me/message" className="text-cyan-300 hover:text-white transition-colors">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/about" className="text-gray-300 hover:text-white transition-colors">About Us</a></li>
              <li><a href="/products" className="text-gray-300 hover:text-white transition-colors">Products</a></li>
              <li><a href="/suppliers" className="text-gray-300 hover:text-white transition-colors">Become a Supplier</a></li>
              <li><a href="/buyers" className="text-gray-300 hover:text-white transition-colors">Buyer Inquiry</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-cyan-300"></i>
                </div>
                <p className="text-gray-300 text-sm">
                  86 Colledge Road, Oke Alafia,<br />
                  Oke Agbo, Ijebu Igbo,<br />
                  Ogun State, Nigeria
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-cyan-300"></i>
                </div>
                <a href="mailto:accounts@henatosbiz.com" className="text-gray-300 hover:text-white transition-colors text-sm">
                  accounts@henatosbiz.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Henatos Limited. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white transition-colors text-sm mt-2 sm:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};
